import { render, staticRenderFns } from "./goodsspu.vue?vue&type=template&id=0414eecf&scoped=true&"
import script from "./goodsspu.vue?vue&type=script&lang=js&"
export * from "./goodsspu.vue?vue&type=script&lang=js&"
import style1 from "./goodsspu.vue?vue&type=style&index=1&id=0414eecf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0414eecf",
  null
  
)

export default component.exports